import React, { Component, useState, useEffect, useContext, ReactNode } from 'react';
import './AllForCommentList.scss';

import { inject, observer } from 'mobx-react';
import { IComponentCommentList } from '../../component.d';
import { IResult } from '../../global.d';

import ThemeList from './ThemeList';
import ThemeFixed from './ThemeFixed';

import GiftTransition from './GiftTransition';

import { PageContext } from '../ComponentNavigatorV2/PageContext';

export enum ICommentType {
  RED_PACKAGE = 'redpackage',
  EMOTION = 'emotion',
  GIFT = 'gift',
  FILE = 'file',
  IMAGE = 'image',
  TEXT = 'text',
  QUESTION = 'question',
  HTML = 'html',
  VOTE = 'vote'
}

export interface IComment {
  id: number;
  gallery_id: number;
  nick_name: string;
  avatar: string;
  content: string;
  has_reply: number;
  reply_id: number;
  replylist?: IComment[];
  master_name?: string;
  type: ICommentType;
  status: string;
  is_top: number;
  video_data: number;
  gallery_data: number;
  is_master: number;
  created_at: string;
  children?: any;
}

export interface ICommentListTheme extends IComponentCommentList {
  onSortChange?: (type: string) => void;
  onFetchList?: (type: string, useLast?: boolean) => PromiseLike<any>;
  onRecomment: (data: IComment) => void;
  messages: IComment[];
  total: number;
  headerExtra?: ReactNode;
  onLoadMore?: (total: number, height: number, top: number) => void;
}

const AllForCommentList = (props: IComponentCommentList) => {
  const { theme, rootStore, onlypage } = props;

  const [activeTheme, setActiveTheme] = useState('');

  const {renderMode} = rootStore.pagedataStore!;
  useEffect(() => {
    if (theme) {
      if(renderMode == 'pc') {
        setActiveTheme('list');
      }else {
        setActiveTheme(theme);
      }
    }
  }, [theme]);

  const {
    formatMessages,
    filter,
    setFilter,
    total
  } = rootStore.commentV2Store!;

  const fetchHistory = (type: string, useLast: boolean = false) => {
    // console.log('fetch history', useLast);
    if (!useLast) {
      rootStore.commentV2Store!.clear();
    }
    return rootStore.commentV2Store!.getHistory(
      window.gallery.id,
      type,
      useLast,
      onlypage
    );
  };

  const onRecomment = (data: IComment) => {
    const { user } = rootStore.wxuserStore!;
    if (user.is_mock) {
      rootStore.wxuserStore!.auth();
      return;
    }

    if (window.configDetail && Number(window.configDetail.block_all) == 1) {
      // 全体禁言
      return;
    } else if (rootStore!.commentV2Store.isblock) {
      // 自己被禁言了
      return;
    }

    let event = new Event('custom-comment-reply');
    event.data = data;
    window.dispatchEvent(event);
  };

  useEffect(() => {
    // 获取历史消息
    fetchHistory(filter);
  }, []);

  const tolerate = 200;
  const checkLoadMore = (
    containerHeight: number,
    scrollHeight: number,
    scrollTop: number
  ) => {
    if (
      scrollTop /* + document.body.clientHeight */ + containerHeight >=
        scrollHeight - tolerate &&
      scrollHeight > containerHeight + tolerate
    ) {
      // @ts-ignore
      fetchHistory(filter, true);
    }
  };

  const context = useContext(PageContext);

  useEffect(() => {
    const theEventName = `page-scroll-bottom-${context.cid}`;

    const toBottomListener = function() {
      fetchHistory(filter, true);
    };
    if (theme == 'list') {
      window.addEventListener(theEventName, toBottomListener, false);
    } else {
      window.removeEventListener(theEventName, toBottomListener);
    }
    return () => {
      window.removeEventListener(theEventName, toBottomListener);
    };
  }, [context.cid, theme]);

  // 应该在父级组件里处理自动加载事件
  useEffect(() => {
    const eventHandler = (e: Event) => {
      if (e && e.type == 'custom-tab-has-comment') {

        setActiveTheme('list');
        window.dispatchEvent(new Event('custom-commentsend-show'));
      }
      if (e && e.type == 'custom-tab-no-comment') {
        setActiveTheme('fixed');
      }
    };

    // theme == 'list' && scrollWrapper.addEventListener('scroll', scrollHandler);
    window.addEventListener('custom-tab-has-comment', eventHandler);
    window.addEventListener('custom-tab-no-comment', eventHandler);

    return () => {
      // scrollWrapper.removeEventListener('scroll', scrollHandler);
      window.removeEventListener('custom-tab-has-comment', eventHandler);
      window.removeEventListener('custom-tab-no-comment', eventHandler);
    };
  }, [filter]);

  return (
    <div className="all-for-commentlist">
      {activeTheme == 'list' ? (
        <ThemeList
          {...(props as IComponentCommentList)}
          onRecomment={onRecomment}
          onSortChange={(e: string) => {
            fetchHistory(e);
            setFilter(e);
          }}
          onFetchList={(type: string, useLast?: boolean) => {
            setFilter(type);
            return fetchHistory(type, useLast);
          }}
          messages={formatMessages}
          total={total}
        />
      ) : null}
      {activeTheme == 'fixed' ? (
        <ThemeFixed
          {...(props as IComponentCommentList)}
          onRecomment={onRecomment}
          onSortChange={(e: string) => {
            fetchHistory(e);
            setFilter(e);
          }}
          onFetchList={(type: string, useLast?: boolean) => {
            setFilter(type);
            return fetchHistory(type, useLast);
          }}
          onLoadMore={checkLoadMore}
          messages={formatMessages}
          total={total}
        />
      ) : null}

      <GiftTransition />
    </div>
  );
};

export default inject('rootStore')(observer(AllForCommentList));
